/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module VsLogsModule */

import { Component, OnInit } from '@angular/core';
import { L10nService } from '@vmw/ngx-vip';

import { wafLatencyPhases } from 'ng/modules/vs-logs/constants/vs-logs-signpost.constants';

import { getWafLatencyRequestParams } from 'ng/modules/vs-logs/utils/vs-logs-signpost.utils';
import { VsLogsSignpostStore } from '../../vs-logs-signpost.store';
import './vs-logs-signpost-custom-waf-latency.component.less';
import * as l10n from './vs-logs-signpost-custom-waf-latency.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Signpost component for WAF Latency section.
 * @author Suraj Kumar
 */
@Component({
    selector: 'vs-logs-signpost-custom-waf-latency',
    templateUrl: './vs-logs-signpost-custom-waf-latency.component.html',
})
export class VsLogsSignpostCustomWafLatencyComponent implements OnInit {
    public readonly wafLatencyPhases = wafLatencyPhases;

    public readonly l10nKeys = l10nKeys;

    constructor(
        public readonly vsLogsSignpostStore: VsLogsSignpostStore,
        l10nService: L10nService,
    ) {
        l10nService.registerSourceBundles(dictionary);
    }

    /** @override */
    public ngOnInit(): void {
        const fullSignpostParams = getWafLatencyRequestParams();

        this.vsLogsSignpostStore.getVsLogSignpostCombinedData(fullSignpostParams);
    }

    /**
     * Callback to ngFor-track by.
     */
    public trackbyIndex(index: number): number {
        return index;
    }
}
